// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1aSqY","modalForm":"UpgradeEpcsModal_modalForm__1IouX","modalFooter":"UpgradeEpcsModal_modalFooter__3NyRk"};